module.exports = __webpack_public_path__ + "static/media/foto_2.a3d296c2.png";